import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters } from "./config";

const PromotionList = () => {

  return (
    <Table tableId="messages/promotions" title="SMS Promotion" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="-date" idKey="sms_promotion_id" disableSearch={true} edit={false} trash={false} />
  );
};

export default PromotionList;